/**
 * dd-image-rotate
 * Rotates any ".js-image-rotate" element proportionally to scroll position.
 *
 * Ports the legacy theme's behavior (assets/custom.js.liquid, jQuery):
 *   var $img = $('.js-image-rotate');
 *   if ($img.length > 0) {
 *     $(window).scroll(function () {
 *       var theta = $(window).scrollTop() / 10;
 *       $img.css({ transform: 'rotate(' + theta + 'deg)' });
 *     });
 *   }
 *
 * Dawn has no jQuery and does not load custom.js.liquid at all (that file is
 * ~89KB of jQuery-bound behavior for many legacy-theme-only sections/features
 * that don't exist in this migration - porting the whole file would require
 * adding jQuery back to Dawn just for this one effect, and risks colliding
 * with Dawn's own vanilla-JS custom elements). This is a small, dependency-
 * free vanilla-JS port of just the rotation behavior, needed by
 * sections/dd-value-prop-sous-vide.liquid's ".dd-vp__media.js-image-rotate"
 * center photo.
 *
 * Include once, site-wide, from layout/theme.liquid:
 *   <script src="{{ 'dd-image-rotate.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  var els = document.querySelectorAll('.js-image-rotate');
  if (!els.length) return;

  function rotate() {
    var theta = window.scrollY / 10;
    var transform = 'rotate(' + theta + 'deg)';
    for (var i = 0; i < els.length; i++) {
      els[i].style.transform = transform;
    }
  }

  window.addEventListener('scroll', rotate, { passive: true });
  rotate();
})();
